import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import Hero from '../components/sections/Hero';
import Marquee from '../components/sections/Marquee';
import Services from '../components/sections/Services';
import Calculators from '../components/sections/Calculators';
import About from '../components/sections/About';
import Testimonials from '../components/sections/Testimonials';
import Faq from '../components/sections/Faq';
import Contact from '../components/sections/Contact';

export default function Landing() {
  return (
    <div className="bg-ink-900 grain">
      <Navigation />
      <Hero />
      <Marquee />
      <Services />
      <Calculators />
      <About />
      <Testimonials />
      <Faq />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
